<template>
        <el-dialog class="message-center" :visible="showDialog" @close="onClose()" width="1100">
            
            <div class="msg-container" >
                <div class="msg-list" v-if="applyList && applyList.length>0">
                <div class="title">
                    申請列表
                </div>
                <div class="msg-list-item" v-for="(item,i) in applyList" :key="i">
                    <div class="msg" @click="selectItem(item)" :class="{'active':curItem.applier == item.applier}" >
                        <p class="applier">{{item.applier}}</p>
                        <div class="member">
                            <span class="member" v-for="(member) in item.ownMember" :key="member">{{member}}</span>
                            換
                            <span class="member" v-for="(member,i) in item.targetMember" :key="i">{{member}} </span>
                        </div>
                        <p class="date">{{item.create_time}}</p>
                    </div>
                </div>
            </div>
            <div class="nodata" v-else>
                <p>無申請資料</p>
            </div>
            <div class="msg-box" v-if="applyList && applyList.length>0">
                <div class="title">
                    <p  v-if="curMessageList.length>0">{{curMessageList[0].fromUser == userName?curMessageList[0].toUser:curMessageList[0].fromUser}}</p>
                    
                </div>
                <div class="msg-detail-container">
                    <div class="msg-detail" v-for="(msg,i) in curMessageList" :key="i" :class="{'self':msg.fromUser == userName}">
                            <div class="text">{{msg.postMessage}}</div> 
                            <div class="date">{{msg.create_time}}</div>
                    </div>
                </div>
                <div class="msg-send">
                        <el-input  class="type-box" autosize maxlength="100" type="textarea" show-word-limit v-model="msgText" placeholder="輸入訊息" ></el-input>
                        <el-button class="btn-send" @click="doSendMessage()">送出</el-button>   
                    </div>
            </div>
            <div class="msg-info">
                <div class="title">
                    物品資訊
                </div>
                <div class="info-container">
                                    <div class="img-container">
                    <img :src="exchangeItem.img?exchangeItem.img:defaultimg">
                    </div>
                <div class="category-group">
                    <p class="category">{{exchangeItem.category}}</p>
                    <p class="album" v-if="exchangeItem.category === '專卡'">{{exchangeItem.groupName}} {{exchangeItem.album}}</p>
                </div>
                <p class="member"><span v-for="(member) in exchangeItem.ownMember" :key="member">{{member}} </span> 換 <span v-for="(member,i) in exchangeItem.targetMember" :key="i">{{member}} </span></p>
                <p class="desc">{{exchangeItem.desc}}</p>
                <p class="note"><span v-for="(note) in exchangeItem.note" :key="note">#{{note}} </span></p>
                
                </div>

            </div>
            </div>
            
        </el-dialog>
        
</template>

<script>
import { mapState } from 'vuex'
import { getApplyList } from '../../../api/exchange'
import { getExchangeMessageList,sendMessage } from '../../../api/message'; 

export default {
    props:{
        showDialog: {
            type: Boolean,
            require: true
        },
        exchangeItem :{
        }
    },
    data(){
        return {
            applyList:[],
            myExchangeList:[],
            defaultimg:require('../../../assets/card1.jpg'),
            curItemId: "",
            curItem:{},
            msgText:"",
            curMessageType:'my',
            curMessageList: [],
            curMessageTypeList:[]
        }
    },
    computed:{
        ...mapState({
            userImg: state => state.user.userImg,
            userName: state => state.user.userName,
        }),
    },
    watch:{
        showDialog(newValue){
            if (newValue){
                this.getApplyListFunc()
            }
        }
    },
    async mounted(){
    },
    methods:{
        getApplyListFunc(){
            getApplyList({
                itemId:this.exchangeItem.itemId
            }).then(res => {
                console.log(res)
                this.applyList = res.messageList
                this.selectItem(this.applyList[0])
                }).catch(err => {
                    console.log(err);
                });
        },
        selectItem(item){
            this.curItemId = item.itemId 
            this.curItem = item
            this.getItemMessage()
        },
        getItemMessage(){
            let params = {
                itemId: this.curItemId,
                applier: this.curItem.applier,
                creator: this.exchangeItem.creator
            }
            getExchangeMessageList(params).then(res => {
                console.log(res);
                this.curMessageList = res.messageList
                }).catch(err => {
                    console.log(err);
                });
        },
        doSendMessage(){
            let curMessageInfo = this.curMessageList[0]
            let params = {
                postMessage:this.msgText,
                fromUser:this.userName,
                toUser:curMessageInfo.fromUser !== this.userName?curMessageInfo.fromUser:curMessageInfo.toUser,
                relatedItem:curMessageInfo.relatedItem
            }
            console.log(params)
            sendMessage(params).then(res => {
                this.getItemMessage()
                this.msgText = ""
                }).catch(err => {
                    console.log(err);
                });
        },
        onClose(){
           this.$emit('update:showDialog', false)
        }
    }
}
</script>

<style lang="scss" scoped>
.msg-container{
    display: flex;
    flex-direction: row;
    height: 500px;
}
.msg-list {
    border-right: 1px solid #ccc;
    width: 30%;
    .title {
        position: relative;
        font-size: 18px;
        font-weight: 600;
        height: 30px;
        border-bottom: 1px solid #ccc;
        padding: 0 10px;
        line-height: 30px;
    }
    .msg-list-item {
        .msg {
            width: 100%;
            border-bottom: 1px solid #ccc;
            height:90px;
            padding: 10px;
            box-sizing: border-box;
            position: relative;
            &.active {
                box-shadow: 0px 5px 10px #ccc;
            }
            .applier {
                font-size: 20px;
            }
            .member {
                color: $textColor;
                margin-top: 10px;
            }
            .date{
                font-size: 12px;
                position: absolute;
                bottom: 5px;
            }
        }
        
        
    }
}
.msg-box{
    border-right: 1px solid #ccc;
    position: relative;
    width: 40%;
    .title {
        font-size: 18px;
        font-weight: 600;
        border-bottom: 1px solid #ccc;
        height: 30px;
        padding: 0 10px;
    }
    .msg-detail-container {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 10px;
    }
    .msg-detail{
        margin: 10px;
        .text {
            display: inline-block;
            background-color: $mainColor;
            padding: 10px;
            border-radius: 10px;
            background-color: #ececec;
            margin: 5px 0;
        }
        .date {
            font-size: 12px;
            color: $textColor;
        }  
        &.self {
           align-self: flex-end;
           display: flex;
           flex-direction: column;
           align-items: flex-end;
            .text {
                background-color: $mainColor;
            }
        }

    }
    .msg-send {
        display: flex;
        width: 90%;
        border: 1px solid #ccc;
        border-radius: 5px;
        position:absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        /deep/ .el-textarea__inner{
            border: none;
        }
        .type-box{
            
        }
        .btn-send{
        }
    }
}
.msg-info {
    width: 30%;
    .title {
        position: relative;
        font-size: 18px;
        font-weight: 600;
        height: 30px;
        border-bottom: 1px solid #ccc;
        padding: 0 10px;
        line-height: 30px;
        margin-bottom: 10px;
    }
    .info-container{
        padding: 10px 20px;
    }
        .img-container{
      width: 100%;
      height: 200px;
      overflow: hidden;
      position: relative;
      border-radius: 10px;
    }
    img {
      width: 100%;
      position: absolute;
      top:50%;
      left: 50%;
      transform: translate(-50%,-50%);
    }
    .category-group {
      margin:10px 0;
      color: #fff;
      .category,.album {
        background-color: $mainColor;
        padding: 5px 10px;
      }
      .album {
        color: $textColor;
      }
    }
    .member {
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 15px;
    }
    .desc,.note {
      color: $textColor;
    }
    .note {
      margin-top: 15px;
    }
}
.nodata{
    padding: 50px;
    font-size: 20px;
    width: 70%;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>